import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { UpdateEmailView } from "../../../views/profile/update-email/update-email-view";

export const Route = createFileRoute("/_profile/profile/update-email")({
  component: () => WithErrorBoundary({ Component: withPermissionCheck({ Component: UpdateEmailView }) }),
});
